import React from 'react'
import { Form, Formik } from 'formik'
import get from 'lodash.get'
import set from 'lodash.set'
import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { Button, Space, message } from 'antd'
import { adjustmentInfos } from '../../../forms/blocks/Adjustment'
import { updateOrder } from '../../../network/Orders'
import { getProductPrices } from '../../../network/ProductPrices'
import FormContent from '../FormContent'

const EditOrderEditAdjustment = React.memo(
  ({ closeMeasure, data, productIndex }) => {
    const { orderId } = useParams()
    const queryClient = useQueryClient()

    const editOrder = useMutation((val) => updateOrder(...val), {
      onSuccess: () => {
        message.success('Order updated !')
        queryClient.invalidateQueries(['getOrderDetails', { id: orderId }])
        closeMeasure()
      },
    })

    return (
      <Formik
        initialValues={data}
        onSubmit={async (values) => {
          const newValues = JSON.parse(JSON.stringify(values))
          let newProductTotal = 0

          for (let i = 0; i < get(values, 'orderProducts', []).length; i++) {
            if (
              get(
                values,
                `orderProducts.${i}.orderAdjustment.itemDescritpion`,
                null
              ) === 'af'
            ) {
              set(newValues, `orderProducts.${i}.orderAdjustment.price`, 0)
            } else {
              let price = 0
              const type = get(
                values,
                `orderProducts.${i}.orderAdjustment.type`,
                ''
              )
              const desc = get(
                values,
                `orderProducts.${i}.orderAdjustment.itemDescritpion`,
                ''
              )

              for (
                let j = 0;
                j <
                get(
                  values,
                  `orderProducts.${i}.orderAdjustment.adjustmentPositions`,
                  []
                ).length;
                j++
              ) {
                const adjType = get(
                  values,
                  `orderProducts.${i}.orderAdjustment.adjustmentPositions.${j}.positionRef`,
                  ''
                )
                let shoesCalculate = {}
                if (type === 'shoes') {
                  shoesCalculate = get(
                    values,
                    `orderProducts.${i}.orderAdjustment.adjustmentPositions.${j}`,
                    {}
                  )
                }

                if (desc !== 'af') {
                  const productPrice = await getProductPrices()
                  const priceData = productPrice.list.products.find(
                    (product) => product.type === type
                  )
                  if (priceData) {
                    let adjustmentData = {}
                    if (shoesCalculate.adjustmentType === 'color') {
                      adjustmentData = priceData.adjustments.find(
                        (adj) => adj.key === shoesCalculate.color
                      )
                    } else if (shoesCalculate.adjustmentType === 'fix') {
                      adjustmentData = priceData.adjustments.find(
                        (adj) => adj.key === shoesCalculate.fix
                      )
                    } else {
                      adjustmentData = priceData.adjustments.find(
                        (adj) => adj.type === adjType
                      )
                    }
                    if (adjustmentData) {
                      price = adjustmentData.price
                    }
                  }
                }
              }

              set(newValues, `orderProducts.${i}.orderAdjustment.price`, price)
              newProductTotal = newProductTotal + price
            }
          }

          const totalSpent = get(values, 'totalSpent', 0) + newProductTotal
          const balance =
            totalSpent -
            get(values, 'deposit', 0) -
            get(values, 'deposit2', 0) -
            get(values, 'discount', 0)

          editOrder.mutate([{ ...newValues, totalSpent, balance }, orderId])
        }}
      >
        {({ values, errors, handleChange }) => (
          <Form style={{ margin: '0px 18px' }}>
            <FormContent
              values={values}
              errors={errors}
              path={`orderProducts.${productIndex}`}
              handleChange={handleChange}
              forms={
                adjustmentInfos[
                  get(
                    values,
                    `orderProducts.${productIndex}.orderAdjustment.type`,
                    null
                  )
                ]?.forms
              }
            />
            <Space style={{ padding: '8px 24px' }}>
              <Button
                loading={editOrder.isLoading}
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
              <Button
                disabled={editOrder.isLoading}
                onClick={closeMeasure}
              >
                Cancel
              </Button>
            </Space>
          </Form>
        )}
      </Formik>
    )
  }
)

EditOrderEditAdjustment.displayName = 'EditOrderEditAdjustment'

export default EditOrderEditAdjustment
